import React, { useState } from "react";
import Rating from "react-rating";
import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";

const StarRating = ({ formikProps, name, label }) => {
    const [hoverValue, setHoverValue] = useState(null);

    return (
        <div className="flex flex-col gap-3 relative">
            <label className="font-medium">{label}</label>

            {/* Dynamic Rating Display */}
            {hoverValue !== null && (
                <div className="absolute -top-6 left-0 bg-gray-800 text-white text-sm px-2 py-1 rounded">
                    {hoverValue.toFixed(1)} ⭐
                </div>
            )}

            <Rating
                initialRating={formikProps.values[name] || 0}
                fractions={10} // Allows 0.1, 0.2, 0.3, ..., 0.9, 0.99
                emptySymbol={<FaRegStar className="text-gray-300 text-2xl" />}
                fullSymbol={<FaStar className="text-yellow-500 text-2xl" />}
                placeholderSymbol={<FaStarHalfAlt className="text-yellow-500 text-2xl" />}
                onChange={(value) => {
                    debugger;
                    formikProps.setFieldValue(name, value);
                }}
                onHover={(value) => setHoverValue(value || null)} 
                onBlur={() => setHoverValue(null)} 
            />
        </div>
    );
};

export { StarRating };
